import { graphql } from '@api/generated';

export const GET_VA_FOLLOW_UPS_COUNT_QUERY = graphql(`
  query vaCount($filter: VAFollowUpFilterInput, $take: Int) {
    vaFollowUps(filter: $filter, take: $take) {
      totalCount
    }
  }
`);
